import { SelectOption, type StepperDataType } from "@revmatics/catalyst";

export const jobTitleOptions: SelectOption[] = [
  { value: "c_suite_executive", label: "C-Suite Executive" },
  { value: "vp_marketing", label: "VP of Marketing" },
  {
    value: "director_sr_dir_marketing",
    label: "Director / Sr Dir. of Marketing",
  },
  { value: "paid_media_management", label: "Paid Media Management" },
  { value: "other", label: "Other" },
];

export const annualizedRevenueOptions: SelectOption[] = [
  { value: "0-100k", label: "$0 - $100,000" },
  { value: "100k-500k", label: "$100,000 - $500,000" },
  { value: "500k-1m", label: "$500,000 - $1,000,000" },
  { value: "1m-3m", label: "$1,000,000 - $3,000,000" },
  { value: "3m-10m", label: "$3,000,000 - $10,000,000" },
  { value: "10m-50m", label: "$10,000,000 - $50,000,000" },
  { value: "50m-100m", label: "$50,000,000 - $100,000,000" },
  { value: "100m+", label: "$100,000,000 +" },
  { value: "unknown", label: "Unknown" },
];

export const signUpStepperData: StepperDataType = [
  { step: 1, title: "Personal details" },
  { step: 2, title: "Company details" },
];
